import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import TechCases from "@/pages/TechCases";
import Invoices from "@/pages/Invoices";
import Settings from "@/pages/Settings";
import Integrations from "@/pages/Integrations";
import Users from "@/pages/Users";
import CallTracking from "@/pages/CallTracking";
import Renewals from "@/pages/Renewals";
import MyCalls from "@/pages/MyCalls";
import EmployeeSpace from "@/pages/EmployeeSpace";
import HRAdmin from "@/pages/HRAdmin";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="h-screen w-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if ((user?.role || "").toLowerCase() !== "admin") return <Navigate to="/" replace />;
  return children;
}

function HrRoute({ children }) {
  const { user } = useAuth();
  if (!["admin", "hr"].includes((user?.role || "").toLowerCase())) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<AdminRoute><Clients /></AdminRoute>} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/tech-cases" element={<TechCases />} />
              <Route path="/my-calls" element={<MyCalls />} />
              <Route path="/outbound-calls" element={<AdminRoute><CallTracking /></AdminRoute>} />
              <Route path="/me" element={<EmployeeSpace />} />
              <Route path="/hr" element={<HrRoute><HRAdmin /></HrRoute>} />
              <Route path="/renewals" element={<AdminRoute><Renewals /></AdminRoute>} />
              <Route path="/invoices" element={<AdminRoute><Invoices /></AdminRoute>} />
              <Route path="/users" element={<AdminRoute><Users /></AdminRoute>} />
              <Route path="/settings" element={<AdminRoute><Settings /></AdminRoute>} />
              <Route path="/integrations" element={<AdminRoute><Integrations /></AdminRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
